/**
 * Markup applied to Livn Direct Connect products that supply **net rates**
 * (non-commissionable). Per Livn's certification guideline the reseller is
 * responsible for adding its own margin before showing such a price to a
 * customer — the API returns the raw net rate.
 *
 * Resolution order (first match wins):
 *   1. `LIVN_SUPPLIER_MARKUP_PERC[supplier.id]`   — per-supplier override
 *   2. `product.netRatesMarkupPerc`               — per-product value from the API
 *   3. `product.commissionPerc`                   — contract commission, when present
 *   4. `LIVN_DEFAULT_MARKUP_PERC`                 — global fallback
 *
 * Only ever applied when `product.usesNetRates === true`; gross (retail) rates
 * are shown exactly as Livn returns them.
 */

/** Percentage added on top of a net rate, keyed by Livn supplier id. */
export const LIVN_SUPPLIER_MARKUP_PERC: Record<number, number> = {
  // 24: 15,  // e.g. Sydney Harbour Cruises — 15% markup
};

/** Used for net-rate suppliers that have no explicit entry above. */
export const LIVN_DEFAULT_MARKUP_PERC = 15;
